/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { polyfill } from 'mobile-drag-drop';

// optional import of scroll behaviour
// import { scrollBehaviourDragImageTranslateOverride } from 'mobile-drag-drop/scroll-behaviour';

// options are optional ;)
polyfill({
  // use this to make use of the scroll behaviour
  // dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride,
  // forceApply: true,
  // holdToDrag: 0, // adds delay before drag starts — helpful for mobile
  // iterationInterval: 10, // how often the drag image is updated
  // defaultActionOverride: (event: TouchEvent) => {
  //   const target = event.target as HTMLElement;
  //   if (target.closest('[draggable="true"]')) {
  //     event.preventDefault(); // only if needed
  //   }
  // },
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

// iOS>=10 supports passive event listeners
var supportsPassive = false;
try {
  window.addEventListener('touchmove', function () {}, { passive: false });
} catch (e) {
  console.log('Saffari browser error', e);
}
